import React from 'react'
import PropTypes from 'prop-types'
import { RadioButton, Icon } from 'loyal-react'

import { States, AddressTypes } from './enum'

const Box = ({ address, handleStep, handleStepOneMode }) => {
  const addressType = AddressTypes.find(item => item.value === address.addressType)
  const state = States.find(item => item.value === address.state)

  function editAddress () {
    handleStep(1)
    handleStepOneMode('add')
  }

  function removeAddress () {
    // TODO: fazer lógica de exclusão
  }

  return (
    <div className='col-11 col-md-5 p-0 mx-md-3 mb-3 bg-white border-color-ui-3 border radius'>
      <a onClick={() => handleStep(2)}>
        <div className='p-2'>
          <p className='mb-1'>
            <strong>{addressType ? addressType.name : ''}</strong>
          </p>
          <p>{`${address.street}, ${address.number} - ${address.complement}`}</p>
          <p className='mb-1'>{address.zipCode}</p>
          <p className='mb-1'>{`${address.city} - ${state ? state.sigla : ''}`}</p>
          <p>
            <strong>Entrega em até 7 dias úteis</strong>
          </p>
        </div>
      </a>
      <div className='border-color-ui-3 border-top d-flex'>
        <label className='d-flex justify-content-center align-items-center col-8 border-color-ui-3 border-right'>
          <RadioButton name='inputAddress' id='inputAddress' labelClass='d-none' />
          <p>Selecionar como principal</p>
        </label>
        <a onClick={editAddress} className='col-2 d-flex justify-content-center align-items-center border-color-ui-3 border-right'>
          <Icon iconName='icon_edit' className='color-brand-2-like' />
        </a>
        <a onClick={removeAddress} className='col-2 d-flex justify-content-center align-items-center'>
          <Icon iconName='icon_trash' className='color-brand-2-like' />
        </a>
      </div>
    </div>
  )
}

Box.propTypes = {
  address: PropTypes.object,
  handleStep: PropTypes.func,
  handleStepOneMode: PropTypes.func
}

export default Box



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Address/Box.js